import React from 'react';
import IconBase from './IconBase';
const ErrorIcon = props => React.createElement(IconBase, props, React.createElement("g", {
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("line", {
  x1: "32",
  y1: "18.9",
  x2: "32",
  y2: "36.5"
}), React.createElement("line", {
  x1: "32",
  y1: "45.9",
  x2: "32",
  y2: "47.4"
}), React.createElement("polygon", {
  points: "43,5.8 20.7,5.8 4.9,21.5 4.9,43.8 20.7,59.6 43,59.6 58.7,43.8 58.7,21.5 "
})));
ErrorIcon.displayName = 'ErrorIcon';
export default ErrorIcon;
//# sourceMappingURL=ErrorIcon.js.map